:host {
  @include font(light);

  background-color: $color-green;
  color: $color-white;
  font-size: $size-title-normal;
  line-height: 1.4;
  padding: 10px 20px;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: $z-index-eyecatcher;

  &::after {
    background-color: transparent;
    border-bottom: transparent 15px solid;
    border-left: #bbd03a 15px solid;
    bottom: -15px;
    content: "";
    position: absolute;
    right: 0;
    width: 0;
  }
}

:host([variant='blue']) {
  background-color: $color-blue-highlight-1;

  &::after {
    border-left-color: $color-blue-highlight-1;
  }
}

:host([variant='round']) {
  @include font(medium);

  align-items: center;
  border-radius: 50%;
  box-sizing: content-box;
  color: #fff;
  display: inline-block;
  display: flex;
  font-size: $size-text-medium;
  justify-content: center;
  max-height: 200px;
  max-width: 200px;
  min-height: 120px;
  min-width: 120px;
  padding: 15px;
  text-align: center;

  &::before {
    content: "";
    display: inline-block;
    height: 0;
    padding-top: 100%;
    vertical-align: middle;
  }

  &::after {
    display: none;
  }
}

:host([variant='bold']) {
  @include font(medium);
}

:host([variant='plain']) {
  @include font(medium);
  font-size: $size-text-medium;
  right: 0;
  top: 15px;
  max-width: 250px;

  @media only screen and (min-width: $bp-m) {
    top: 30px;
    max-width: 100%;
  }

  &::after {
    content: none;
  }
}